import React, { useEffect, useCallback } from 'react'
import {Button} from 'Components';
import { useDispatch, useSelector } from "react-redux";
import {
	setChangeSelectLanguage,
	getUserLanguage
} from "Redux/actions";
import { useIntl } from 'react-intl';

const ToggleLanguage = ({className}) => {
    const dispatch = useDispatch();

    const language = useSelector(state => state.securityRedux?.language);
	const { messages } = useIntl();


    const currentLan = language || localStorage.getItem('lan') || 'en';
    const nextLan = currentLan === 'en' ? 'es' : 'en';
    const nextLabel = messages[nextLan === 'en' ? 'lan_english' : 'lan_spanish'];

    const applyLanguage = useCallback((lan) => {
        dispatch(setChangeSelectLanguage(lan))
        localStorage.setItem('lan', lan)
        dispatch(getUserLanguage())
    }, [dispatch])

    const onChangeLan = () => {
        applyLanguage(nextLan)
    }

	useEffect(() => {
		const lan = localStorage.getItem('lan')
		if(!lan){
			applyLanguage('en')
		}else{
			applyLanguage(lan)
		}
	},[])

    useEffect(() => {
        const onStorageChange = (e) => {
            if(e.key === 'lan' && e.newValue){
                applyLanguage(e.newValue)
            }
        }
        window.addEventListener('storage', onStorageChange)
        return () => window.removeEventListener('storage', onStorageChange)
    }, [applyLanguage])

  return (
    <Button
		type="button"
		className={`${className ? className : "btn-blue"} full-width" `}
		onClick={() => onChangeLan()}>
		{nextLabel}
	</Button>
  )
}

export default ToggleLanguage